module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABDklEQVQ4ja3TzSqEURgH8N/IViTTJPJZ02QxGwsLC9NLyR3YuAAXJM0duAGRfIxkYSFlMYnyGdJI5AYs3qM0TdM7c5zt+ffr/5yek5PhVKvVEjawhpd22Z4sIDaR4Aij/wGuoo4ijjEeC76hgktMoYbJGBAaWMQFJgI6HQPCO5ZwjjHp+MUYED4CeoYRadNSDAifWMYphgM6EwPCF1ZwgkJAyzEgfAe0hjwOYsHmk4sF+7Aj3dEGkt4IrB/bmJcufoJ6t+AAdjGH14BdQTfgIPYwi+eAXf9edvqGQ9gP2CMW/mKdNswHrIz70OyuOZQVLOBQ+htuA/bQKph15K2A3UhXpCXWCbgeGlbw1C74A6dTNfpWKmunAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/right3.png
// module id = CoxR
// module chunks = 30